export const parseFormattedNumber = (formattedNumber: string): number => {
  const number = parseFloat(formattedNumber?.replace(/,/g, ''));

  if (isNaN(number)) return 0;

  return parseFloat(number.toFixed(2));
};
